import React, { useState } from 'react';
import { IdsSectionNotice } from '@investec/ids-web-react';
import './FISAPenaltyNotice.scss';

const FISAPenaltyNotice = (/** @type {{earlyClosureFee: string, originalBalance: number, interestRate: number, productName: string}} */ { earlyClosureFee, originalBalance: _unused1, interestRate: _unused2, productName }) => {
  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  return (
    <div className="fisa-penalty-notice">
      <IdsSectionNotice appearance="information" title={`Closing your ${productName || 'Fixed Rate Cash ISA'} early`}>
        <p>
          If you choose to close your account before the end of the term, an{' '}
          <strong>early closure fee of £{earlyClosureFee}</strong> may apply.
        </p>
        <button
          className="fisa-penalty-notice__toggle"
          onClick={toggleDetails}
          type="button"
          aria-expanded={showDetails}
        >
          <span>{showDetails ? 'Hide' : 'Show'} details</span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d={showDetails ? 'm4 10 4-4 4 4' : 'm4 6 4 4 4-4'}
              stroke="#30384a"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {showDetails && (
          <div className="fisa-penalty-notice__details">
            <div className="fisa-penalty-notice__details-content">
              <p>
                <strong>How we calculate the early closure fee</strong>
                <br />
                We work out the early closure fee based on 90 days&apos; worth of interest. It&apos;s calculated using:
              </p>
              <ul>
                <li>Your capital ISA balance</li>
                <li>Your account&apos;s interest rate</li>
                <li>365 days in a year (we always use 365, even in a leap year)</li>
              </ul>
              <p>
                Example:
                <br />
                If you opened your ISA with £10,000 and your interest rate is 4%, the fee would be:
                <br />
                £10,000 × 0.04 ÷ 365 × 90 = £98.63
              </p>
            </div>
          </div>
        )}
      </IdsSectionNotice>
    </div>
  );
};

export default FISAPenaltyNotice;
